var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 378,
    height: 279,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M296.062 26.96h-83.541c-7.443 0-13.48-6.037-13.48-13.48S205.078 0 212.521 0h83.541c7.443 0 13.48 6.037 13.48 13.48.006 7.443-6.031 13.48-13.48 13.48",
    opacity: 0.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2DFDB",
    d: "M317.551 278.467H178.08c-12.431 0-22.508-10.077-22.508-22.508s10.077-22.507 22.508-22.507h139.471c12.431 0 22.508 10.077 22.508 22.507s-10.077 22.508-22.508 22.508M191.542 210.015H57.828c-11.916 0-21.579-9.664-21.579-21.579s9.663-21.578 21.579-21.578h133.714c11.915 0 21.578 9.663 21.578 21.578 0 11.922-9.656 21.579-21.578 21.579",
    opacity: 0.38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M349.436 112.339H172.438c-15.777 0-28.564-12.787-28.564-28.564s12.787-28.563 28.564-28.563h176.998c15.777 0 28.564 12.787 28.564 28.563 0 15.77-12.787 28.564-28.564 28.564",
    opacity: 0.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.366 12.61h115.927c9.943 0 18.01 8.06 18.01 18.01v214.996c0 9.943-8.061 18.009-18.01 18.009H153.366c-9.944 0-18.01-8.06-18.01-18.009V30.619c0-9.943 8.06-18.01 18.01-18.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M138.995 12.61h115.927c9.944 0 18.01 8.06 18.01 18.01v214.996c0 9.943-8.06 18.009-18.01 18.009H138.995c-9.943 0-18.01-8.06-18.01-18.009V30.619c0-9.943 8.061-18.01 18.01-18.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M132.952 29.487H260.96a3.346 3.346 0 0 1 3.346 3.346v202.909a3.346 3.346 0 0 1-3.346 3.346H132.952a3.346 3.346 0 0 1-3.346-3.346V32.832a3.34 3.34 0 0 1 3.346-3.346"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M196.956 255.96a4.79 4.79 0 1 0 0-9.58 4.79 4.79 0 0 0 0 9.58M175.473 20.733h42.966"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 212,
    height: 211,
    x: 53,
    y: 29,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.286 29.488h203.667a3.347 3.347 0 0 1 3.346 3.346v202.909a3.346 3.346 0 0 1-3.346 3.346H57.286a3.346 3.346 0 0 1-3.346-3.346V32.833a3.35 3.35 0 0 1 3.346-3.345"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00838F",
    d: "M88.923 157.604s2.691-8.111 17.03-10.217c.007-.006-4.822 9.18-17.03 10.217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M173.527 204.369c-30.676 3.569-70.258-16.585-59.558-52.254 10.701-35.663 49.188-37.75 55.607-39.887s16.763-8.2 9.988-29.957 9.351-31.878 19.619-33.17c10.872-1.367 20.688 5.707 22.825 12.126 0 0 18.322-4.453 24.251 13.194 5.14 15.306-10.344 24.963-6.063 35.663 4.282 10.7 31.388 12.125 23.894 38.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M126.788 163.025c10.7-35.663 41.554-40.93 47.973-43.068s19.224-8.232 11.164-37.686c-6.018-21.98 2.99-31.878 13.258-33.17-10.261 1.292-26.394 11.413-19.619 33.17s-3.569 27.819-9.988 29.957c-6.419 2.137-44.906 4.224-55.607 39.887-5.579 18.589 2.513 32.966 15.873 41.961-5.605-6.68-7.348-16.737-3.054-31.051"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M231.933 98.073a3.75 3.75 0 0 1-3.747 3.747 3.75 3.75 0 0 1-3.747-3.747 3.75 3.75 0 0 1 3.747-3.747 3.75 3.75 0 0 1 3.747 3.747M210.596 121.719s1.202 4.81-2.761 9.924c0 0-7.482 8.054-1.928 11.419 4.975 3.016 35.759 3.951 28.595-11.005 0 0-11.279-6.788-8.855-27.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE2C0",
    d: "M210.596 121.719s.624 2.532-.54 5.872c6.883-3.919 13.461-12.348 13.912-21.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M212.899 76.068c-.77-.14-1.54-.223-2.303-.223-8.862 0-16.051 9.899-16.051 22.113s3.976 24.251 12.838 24.251 21.401-12.043 21.401-24.25c0-1.515-.147-2.997-.414-4.422-7.723-4.51-12.564-11.553-15.471-17.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M215.946 93.15a1.605 1.605 0 0 1-3.207 0c0-.885.719-1.603 1.603-1.603a1.597 1.597 0 0 1 1.604 1.603M200.429 93.15a1.604 1.604 0 0 1-3.206 0c0-.885.719-1.603 1.603-1.603a1.596 1.596 0 0 1 1.603 1.603"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616161",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M198.826 101.425a7.08 7.08 0 1 0-.001-14.161 7.08 7.08 0 0 0 .001 14.161ZM215.945 101.425a7.08 7.08 0 1 0-.001-14.161 7.08 7.08 0 0 0 .001 14.161Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M196.91 84.542h3.881M212.402 84.542h3.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616161",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M205.906 94.345h2.958"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M223.025 94.345h6.832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.273 152.674s-6.266-14.015-11.19-21.903-10.134-9.65-8.652-6.094 4.657 7.697-3.346 4.44c-2.023-.821-4.88-.693-7.685-1.8-3.016-1.19-6.056-3.219-8.531-3.448-3.047-.28.216 2.474 5.02 7.685 2.277 2.468 8.505 4.758 11.291 5.509 7.723 2.093 9.568 21.826 9.568 21.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M207.835 131.643c-26.216 0-63.553 43.844-63.553 43.844s-22.99-12.774-38.322-28.106c0 0-3.88 7.755-17.03 10.217 0 0 16.394 87.504 84.737 51.733l-3.83 40.879H277.78l-1.272-51.312s17.24 25.764 30.014 55.142h27.896s-21.172-118.16-99.903-121.99c0 0-4.001 8.302-16.775 8.302-12.781.006-9.905-8.709-9.905-8.709"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M214.769 145.677c3.995 0 7.767-.738 11.069-1.756 16.947-5.204 35.39-3.257 50.333 6.285 13.855 8.855 24.619 21.617 32.908 35.186-15.433-26.801-39.193-51.624-74.577-53.342 0 0-4.001 8.302-16.775 8.302s-9.899-8.716-9.899-8.716-5.833 14.041 6.941 14.041"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m173.66 209.337-3.829 40.879h23.798c-3.982-5.91-6.997-13.703-8.295-23.951-6.387-50.365-11.496-39.054-11.674-16.928",
    opacity: 0.31
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.079 154.796a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M167.792 154.796a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M183.512 154.796a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M101.131 251.169a2.92 2.92 0 1 1-5.84 0 2.92 2.92 0 0 1 5.84 0M113.923 254.089a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M132.564 251.169a2.92 2.92 0 1 1-5.842-.002 2.92 2.92 0 0 1 5.842.002M314.187 101.447a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M329.907 101.447a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M345.626 101.447a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M121.355 119.165H21.897c-11.909 0-21.565-9.657-21.565-21.566 0-11.91 9.656-21.566 21.565-21.566h99.458c11.908 0 21.565 9.657 21.565 21.566s-9.657 21.566-21.565 21.566"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M130.12 77.89c4.714 3.957 7.71 9.893 7.71 16.528 0 11.909-9.657 21.566-21.566 21.566H16.807c-3.123 0-6.088-.668-8.766-1.864a21.47 21.47 0 0 0 13.856 5.045h99.457c11.909 0 21.566-9.657 21.566-21.566 0-8.792-5.262-16.35-12.8-19.708",
    opacity: 0.37
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "m26.402 90.136 2.424 4.911 5.42.79-3.925 3.822.928 5.395-4.847-2.551-4.848 2.551.93-5.395-3.926-3.823 5.42-.789z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m49.011 90.136 2.424 4.911 5.42.79-3.919 3.822.923 5.395-4.848-2.551-4.84 2.551.922-5.395-3.92-3.823 5.415-.789zM71.627 90.136l2.423 4.911 5.414.79-3.919 3.822.923 5.395-4.841-2.551-4.848 2.551.922-5.395-3.918-3.823 5.42-.789zM94.236 90.136l2.424 4.911 5.413.79-3.918 3.822.928 5.395-4.847-2.551-4.848 2.551.93-5.395-3.926-3.823 5.42-.789zM116.844 90.136l2.424 4.911 5.42.79-3.925 3.822.929 5.395-4.848-2.551-4.847 2.551.929-5.395-3.919-3.823 5.414-.789zM140.114 43.341a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M155.834 43.341a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M171.553 43.341a2.92 2.92 0 1 0 0-5.84 2.92 2.92 0 0 0 0 5.84M162.036 66.726H79.934a5.756 5.756 0 0 1-5.758-5.757 5.756 5.756 0 0 1 5.757-5.757h82.11a5.756 5.756 0 1 1-.007 11.514"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M264.299 33.837v-1.011a3.346 3.346 0 0 0-3.346-3.346H132.952a3.347 3.347 0 0 0-3.347 3.346v1.011z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M129.605 229.774v5.961a3.346 3.346 0 0 0 3.347 3.346H260.96a3.346 3.346 0 0 0 3.346-3.346v-5.961z",
    opacity: 0.45
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M260.96 29.486H132.952a3.347 3.347 0 0 0-3.347 3.346v.172a3.3 3.3 0 0 1 1.438-.337h128.008a3.346 3.346 0 0 1 3.346 3.346v170.929a3.34 3.34 0 0 0 1.909-3.009V32.832a3.35 3.35 0 0 0-3.346-3.346"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M287.295 227.916c21.804 0 39.48-17.675 39.48-39.48s-17.676-39.48-39.48-39.48c-21.805 0-39.481 17.676-39.481 39.48 0 21.805 17.676 39.48 39.481 39.48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M310.572 156.558c7.621 7.195 12.386 17.392 12.386 28.703 0 21.802-17.672 39.48-39.48 39.48a39.3 39.3 0 0 1-23.277-7.595c7.068 6.679 16.598 10.776 27.094 10.776 21.801 0 39.48-17.672 39.48-39.48 0-13.105-6.387-24.702-16.203-31.884",
    opacity: 0.37
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M306.411 192.075a3.46 3.46 0 0 1 3.442 3.798c-.172 1.8-1.781 3.117-3.588 3.117h-14.574c1.1 4.765 2.086 10.14-.236 14.046-1.189 2.004-2.672 2.628-3.906 2.736-1.139.102-2.055-.929-1.883-2.055.216-1.444.274-2.271-.496-6.552-.522-2.895-2.303-5.198-4.192-7.335-2.481-2.806-3.824-5.815-4.39-7.303a5 5 0 0 1-.324-1.807v-13.054a5.14 5.14 0 0 1 2.652-4.504c1.623-.897 3.658-1.832 5.096-1.832h17.933c1.807 0 3.417 1.317 3.588 3.117a3.46 3.46 0 0 1-3.441 3.798h2.602c1.806 0 3.416 1.317 3.588 3.117a3.46 3.46 0 0 1-3.442 3.798h1.425c1.807 0 3.416 1.317 3.588 3.117a3.466 3.466 0 0 1-3.442 3.798M272.064 172.902h-4.739a2.607 2.607 0 0 0-2.608 2.608v16.814a2.61 2.61 0 0 0 2.608 2.608h4.739a2.613 2.613 0 0 0 2.609-2.608V175.51a2.607 2.607 0 0 0-2.609-2.608"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M316.725 168.995c11.067 0 20.039-8.971 20.039-20.039 0-11.067-8.972-20.039-20.039-20.039s-20.039 8.972-20.039 20.039 8.971 20.039 20.039 20.039"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M309.682 159.649a9.94 9.94 0 0 1 7.042-2.92 9.9 9.9 0 0 1 7.042 2.92"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M308.282 147.804a2.13 2.13 0 1 0 0-4.262 2.13 2.13 0 0 0 0 4.262M327.29 145.673a2.13 2.13 0 0 1-2.125 2.131 2.13 2.13 0 1 1 0-4.262c1.177 0 2.125.954 2.125 2.131"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m323.975 140.608 5.929 2.494M309.471 140.608l-5.929 2.494"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 196.954,
    x2: 196.954,
    y1: 263.623,
    y2: 12.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7464E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2DFDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 265.24,
    x2: 125.853,
    y1: 134.285,
    y2: 134.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 112.187,
    x2: 265.397,
    y1: 126.85,
    y2: 126.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 112.188,
    x2: 199.184,
    y1: 121.589,
    y2: 121.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 275.227,
    x2: 106.645,
    y1: 227.623,
    y2: 132.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 285.589,
    x2: 211.636,
    y1: 169.418,
    y2: 127.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 182.038,
    x2: 178.221,
    y1: 254.802,
    y2: 198.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 31.508,
    x2: 111.739,
    y1: 57.481,
    y2: 137.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 48.121,
    x2: 111.767,
    y1: 74.038,
    y2: 137.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 265.239,
    x2: 125.852,
    y1: 31.663,
    y2: 31.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 259.377,
    x2: 315.209,
    y1: 160.522,
    y2: 216.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 282.998,
    x2: 315.217,
    y1: 184.128,
    y2: 216.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 302.555,
    x2: 330.895,
    y1: 134.789,
    y2: 163.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26C6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewImg);
export default __webpack_public_path__ + "static/media/review-img.d109081bb62be7e6c2b307f284a986a7.svg";
export { ForwardRef as ReactComponent };